import Url, { TQueryParams } from "../Url";
import EventEmitter from "events";
import * as _ from "lodash";

export type TQueryParamsNull = {[key:string]:string|boolean|number|null};

export default class Path extends EventEmitter {
    private url:Url|null = null;
    private history:string[] = [];
    private _data:any = null

    static i:Path;

    constructor(){
        super();
        if (typeof(window)!="undefined") {
            Path.i = this;
            window.onpopstate = this.onPopState.bind(this);
        }
        (window as any).path = this;
    }

    // given a url http://host:port/path1/path2/filename?blah=test#frag

    // returns filename
    get filename() : string { return this.url?.filename || "" }
    // returns /path1/path2/filename
    get path() : string { return this.url?.path || "/" }
    // returns /path1/path2
    get pathname() : string { return this.url?.pathname || "/" }
    // returns {blah:test}
    get query() : TQueryParams { return this.url?.query || {} }
    // returns "?blah=test"
    get queryString() : string { return "?"+Url.queryToString(this.query) }
    // returns "frag"
    get hash() : string { return this.url?.fragment || "" }

    get top(){ return this.history.length ? _.last(this.history) : null}
    get data(){ return this._data}

    onPopState(data:any){
        this._data = data
        this.emit("change",this.parse(""+document.location));
        return this;
    }
    parse(url:string){
        this.url = new Url(url)
        return(this);
    }
    set(url:Url|string, title:string="", data:any={}){
        if (typeof(url)=="string" && !/^https?\:/.test(url)) {
            const href = document.location;
            url = `${href.protocol}//${href.host}${url}`
            if (url.indexOf("?")<0) url += this.queryString
        }
        const uri = url.toString()
        window.history.pushState(data, title, uri);
        this.history.push(uri);
        this.onPopState(data);
    }
    replace(url:Url|string, title="", data:any={}){
        const uri = url.toString()
        window.history.replaceState(data, title, uri);
        if (this.history.length) this.history[this.history.length-1] = uri;
        this.onPopState(data);
    }
    setParams(params:TQueryParamsNull) {
        const query : {[key:string]:any} = {...this.query}
        for(let key in params) {
            const val = params[key]
            if (val===null || val===undefined || val===false) delete query[key]
            else if (val===true) query[key] = ""
            else query[key] = params[key]
        }
        const hash = this.hash ? `#${this.hash}` : ""
        this.replace("?" + Url.queryToString(query) + hash)
    }
    setPage(key:string, page:number) {
        this.setParams({[key]:page.toString()})
    }
    setSearch(search:string){
        this.setParams({search:search.toUpperCase()})
    }
    setHash(hash:string){
        if (!this.url) return
        else return this.replace(this.url.clone.setHash(hash))
    }
    back(){
        if (this.history.length) {
            this.history.pop();
            window.history.back();
        }
    }
}
